import s from '../../utils/s'

const Paragraph = s('p')`db lh-copy serif fw1 mv0 f4 f3-m f2-l measure 
baskerville`

export default Paragraph


// WEBPACK FOOTER //
// ./components/paragraph/index.js